var React = require('react');

function MoreHorizontal (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"1","key":0}),React.createElement("circle",{"cx":"19","cy":"12","r":"1","key":1}),React.createElement("circle",{"cx":"5","cy":"12","r":"1","key":2})]);
}

MoreHorizontal.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-more-horizontal"};

module.exports = MoreHorizontal;

MoreHorizontal.default = MoreHorizontal;
